// Centralised palette + helpers shared by TreeView, OffCanvasRight and the
// CSS variables in App.css. Two themes (dark/light) keep the same accent
// hues — only the neutral surfaces flip — so structural-stage colours stay
// recognisable when the user toggles. The accent palette intentionally
// avoids the Bootstrap-style success-green / danger-red / warning-amber
// triplet: insert is teal, delete is rose, search is violet.

const ACCENTS = {
  insert:          '#317b63',
  delete:          '#e75b45',
  search:          '#356e8d',
  info:            '#356e8d',
  random:          '#6e5b87',
  clear:           '#6e746e',
  log:             '#356e8d',
  overflow:        '#d17a36',
  split:           '#317b63',
  'root-split':    '#317b63',
  merge:           '#6e5b87',
  'merge-drop':    '#6e5b87',
  'borrow-left':   '#356e8d',
  'borrow-right':  '#356e8d',
  'replace-pred':  '#c2992d',
  'replace-succ':  '#c2992d',
  'leaf-insert':   '#317b63',
  'leaf-delete':   '#e75b45',
  'root-collapse': '#6e5b87',
};

export const THEMES = {
  dark: {
    name: 'dark',
    bg:           '#172523',
    panel:        '#293b37',
    panelAlt:     '#334640',
    border:       '#657068',
    text:         '#f4ecd9',
    textDim:      '#b9b9aa',
    nodeBg:       '#293b37',
    nodeBorder:   '#839087',
    keyDivider:   '#657068',
    keyText:      '#f4ecd9',
    edge:         '#78877e',
    edgeLit:      ACCENTS.search,
    bannerBg:     'rgba(33, 51, 48, 0.94)',
    bannerCaption:'#ded7c8',
    activeKeyBg:  'rgba(167, 139, 250, 0.18)',
    activeKeyText:'#f5f3ff',
    deleteKeyBg:  'rgba(244, 63, 94, 0.28)',
    deleteKeyText:'#fecdd3',
    medianKeyBg:  '#fbbf24',
    medianKeyText:'#1c1400',
    chipStroke:   'rgba(255,255,255,0.35)',
    accents:      ACCENTS,
  },
  light: {
    name: 'light',
    bg:           '#e8e2d4',
    panel:        '#efe9dc',
    panelAlt:     '#ded7c8',
    border:       '#aaa99d',
    text:         '#172c2b',
    textDim:      '#59625d',
    nodeBg:       '#fffdf6',
    nodeBorder:   '#172c2b',
    keyDivider:   '#aaa99d',
    keyText:      '#172c2b',
    edge:         '#66756d',
    edgeLit:      '#356e8d',
    bannerBg:     'rgba(247, 242, 231, 0.96)',
    bannerCaption:'#59625d',
    activeKeyBg:  'rgba(124, 58, 237, 0.16)',
    activeKeyText:'#3b0764',
    deleteKeyBg:  'rgba(244, 63, 94, 0.22)',
    deleteKeyText:'#9f1239',
    medianKeyBg:  '#f59e0b',
    medianKeyText:'#1c1400',
    chipStroke:   'rgba(15, 23, 42, 0.25)',
    accents:      ACCENTS,
  },
};

// Picked so chip text reads cleanly on each accent background.
const CHIP_FG = {
  insert: '#052e1f',
  delete: '#fff1f3',
  search: '#1c0a3d',
};

export function chipColors(theme, operation) {
  const bg = theme.accents[operation] || theme.accents.info;
  return { bg, fg: CHIP_FG[operation] || '#ffffff' };
}

export function kindColor(theme, kind) {
  return theme.accents[kind] || theme.accents.info;
}
